import { useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { useSessionData } from '@confluence/session-data';
import type { FlagsStateContainer } from '@confluence/flags';

import { triggerInviteOnPublishExperiment } from '../services/run-invite-on-publish';
import { isFeatureGateOn } from '../services/feature-flag';

export const useInviteOnPublishExperiment = (flags?: FlagsStateContainer) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { cloudId, userId } = useSessionData();

	return useCallback(
		async (pageVersion: number) => {
			if (!isFeatureGateOn() || pageVersion > 1) {
				return;
			}
			void triggerInviteOnPublishExperiment({ cloudId, userId, createAnalyticsEvent, flags });
		},
		[cloudId, createAnalyticsEvent, flags, userId],
	);
};
